import { useEffect } from 'react';
import { useFormContext } from "../context/FormContext/index.js";
export function useCustomRule(customRule) {
  const formContext = useFormContext();
  useEffect(() => {
    if (!customRule) {
      return;
    }
    customRule(formContext);
  }, [customRule, formContext]);
}